import script from "./SignupForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SignupForm.vue?vue&type=script&setup=true&lang=js"

import "./SignupForm.vue?vue&type=style&index=0&id=7af51d8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7af51d8c"]])

export default __exports__